<template>
  <div class="request-subjects text-dark">
    <div class="request-subjects__header">
      <div class="request-subjects__header__left">
        <h1>Reduktioner</h1>
        <ChangeSchoolYear :whiteTheme="true"></ChangeSchoolYear>
      </div>
      <button
        class="do-bttn do-bttn--large do-bttn--submit"
        :class="{'do-bttn--submit--loading': isRefreshingOrLoadingSubjects}"
        @click="refreshReductions">
        Opdater reduktioner
      </button>
    </div>
    <div class="request-subjects-grid">
      <div class="doTable">
        <div class="subject-dist__header">
          <div class="subject-dist__header__left">
            <Tabslist
              :tabs="['Aktiviteter', 'Fag']"
              :isLarge="true"
              :selected="selectedTab"
              @select="onSelectTab"></Tabslist>
            <div class="do-search" v-if="selectedTab === 'Fag'">
              <input type="search" class="do-input" placeholder="Søg på fag" @input="debounceSearch">
            </div>
            <DoFiltersFilter
              v-if="selectedTab === 'Fag'"
              :title="'Klasser'"
              :tags="klassTags"
              :selectedTags="selectedKlassFilters"
              @select="toggleKlassTag"
              @clear="selectedKlassFilters = []"
            >
            </DoFiltersFilter>
            <Loader :is-extra-small="true" v-if="isRefreshingOrLoadingSubjects" style="margin: 0"></Loader>
          </div>
        </div>
        <BulkCreateSubjects
          v-if="selectedTab === 'Aktiviteter'"
          :isActivities="true"
          :prop-is-subject-modal="isCreateActivityModal"
          @closeSubjectModal="setIsCreateActivityModal(false)">
        </BulkCreateSubjects>
        <ul class="doTable__items" v-else>
          <li class="doTable__klass"
              v-for="(klassCal, idx) in filteredKlassCals"
              :key="klassCal.id">
            <div class="doTable__klass__header">
              <div>{{ klassCal.name }}</div>
              <p>
                <label>FØR</label> {{ klassCal.vSubjectsSumRaw }} <label>|</label>
                <label>EFTER</label> {{ klassCal.vSubjectsSum }}</p>
            </div>
            <ul class="grade-subjects">
              <li class="grade-subjects_subject"
                  v-for="subject in klassCal.vSubjects"
                  :key="subject.id"
                  :style="{'background': subject.color}"
                  @click="setEditSubject(subject)">
                {{ subject.name }} ({{ subject.vHours }})
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <SubjectForm
      v-if="editSubject"
      :showModal="editSubject"
      :editSubject="editSubject"
      :propTab="'reductions'"
      :isActivities="true"
      @close="closeEditSubjectModal"
      @deleteSubject="deleteSubject"
      @updateSubject="updateSubject">
    </SubjectForm>
  </div>
</template>
<script>
import Loader from '../common/Loader.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'
import Tabslist from '../common/Tabslist.vue'
import DModal from '../common/DModal.vue'
import BulkCreateSubjects from '../SubjectsDistribution/BulkCreateSubjects.vue'
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import docendo from '../../docendo'
import SubjectForm from '../Subjects/SubjectForm.vue'

export default {
  components: {SubjectForm, ChangeSchoolYear, BulkCreateSubjects, DModal, Tabslist, DoFiltersFilter, Loader},
  data () {
    return {
      selectedTab: 'Aktiviteter',
      selectedKlassFilters: [],
      statusFilters: [],
      selectedStatusFilters: [],
      loadingSubjects: {},
      subjectSearchQuery: '',
      debounceTimer: null,
      isCreateActivityModal: false,
      editSubject: null,
      isRefreshing: false
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    schoolYearId () {
      return this.$store.getters.schoolYearId
    },
    user () {
      return this.$store.state.user
    },
    userCalendarId () {
      return this.user && this.user.user_calendar_id ? this.user.user_calendar_id : null
    },
    isLoading () {
      return this.$store.state.subjects.isLoading
    },
    isLoadingSubjects () {
      return this.$store.state.subjects.isLoadingSubjects
    },
    isRefreshingOrLoadingSubjects () {
      return this.isRefreshing || this.isLoadingSubjects
    },
    subjects () {
      return this.$store.state.subjects.subjects
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    subjectsInKlassHash () {
      return this.$store.getters.subjectsInKlassHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    subjectsInUserHash () {
      return this.$store.getters.subjectsInUserHash
    },
    klassCalendars () {
      const cals = []
      const seenIds = new Set()
      this.subjects.forEach(subject => {
        subject.cals.forEach(cal => {
          if (cal.calendar_type === 'klass' && !seenIds.has(cal.id)) {
            seenIds.add(cal.id)
            cals.push(cal)
          }
        })
      })
      return cals.sort((a, b) => a.name.localeCompare(b.name))
    },
    klassTags () {
      return this.klassCalendars.map(klassCalendar => klassCalendar.name)
    },
    calsWithProps () {
      const klasses = this.klassCalendars

      return klasses.map(klass => {
        const vSubjects = (this.subjectsInKlassHash[klass.id] || []).map(subjectId => {
          const subject = this.subjectsInHash[subjectId] || {}

          let calendarHours = null

          if (subject.subject_calendars) {
            const match = subject.subject_calendars.find(sc => sc.calendar_id === klass.id)
            if (match) {
              calendarHours = parseFloat(match.hours)
            }
          }

          const fallbackHours = parseFloat(subject.hours)
          const vHours = isNaN(calendarHours) ? fallbackHours : calendarHours

          return {
            ...subject,
            vHours
          }
        })
        // Sum af subject.hours (rå data)
        const sumHours = vSubjects.reduce((sum, subject) => {
          const raw = parseFloat(subject.hours)
          return sum + (isNaN(raw) ? 0 : raw)
        }, 0)

        // Sum af vHours (baseret på kalenderdata hvis muligt)
        const sumVHours = vSubjects.reduce((sum, subject) => {
          return sum + (isNaN(subject.vHours) ? 0 : subject.vHours)
        }, 0)

        return {
          ...klass,
          vSubjects,
          sumHours: parseFloat(sumHours.toFixed(2)),
          sumVHours: parseFloat(sumVHours.toFixed(2))
        }
      })
    },
    filteredKlassCals () {
      let klasses = this.calsWithProps

      if (this.selectedKlassFilters.length > 0) {
        klasses = klasses.filter(klass => this.selectedKlassFilters.includes(klass.name))
      }

      return klasses.map(klass => {
        const vSubjects = klass.vSubjects.filter(subject => {
          const matchesStatusFilter = this.selectedTab === 'Fag'
            ? subject.subject_type === 'subject' || subject.subject_type === 'optional' || subject.subject_type === 'activity'
            : subject.subject_type === 'frame'

          const matchesSearch = !this.subjectSearchQuery ||
            subject.name.toLowerCase().includes(this.subjectSearchQuery.toLowerCase())

          return matchesStatusFilter && matchesSearch
        })

        // vHours medregner alle – også activity
        const rawSumVHours = vSubjects.reduce((sum, subject) => {
          return sum + (isNaN(subject.vHours) ? 0 : subject.vHours)
        }, 0)

        // subject.hours ekskluderer activity
        const rawSumHours = vSubjects.reduce((sum, subject) => {
          if (subject.subject_type === 'activity') return sum
          const raw = parseFloat(subject.hours)
          return sum + (isNaN(raw) ? 0 : raw)
        }, 0)

        return {
          ...klass,
          vSubjects,
          vSubjectsSum: parseFloat(rawSumVHours.toFixed(2)),
          vSubjectsSumRaw: parseFloat(rawSumHours.toFixed(2))
        }
      })
    }
  },
  methods: {
    updateSubject (updatedSubject) {
      updatedSubject['schoolId'] = this.schoolId
      updatedSubject['schoolYearId'] = this.activeSchoolYear.id
      this.$store.dispatch('updateSubject', updatedSubject)
      this.closeEditSubjectModal()
    },
    closeEditSubjectModal () {
      this.editSubject = null
    },
    setEditSubject (editSubject) {
      this.editSubject = Object.assign({}, editSubject)
    },
    deleteSubject (editSubject) {
      let deletedSubject = {
        id: editSubject.id,
        school_id: editSubject.school_id,
        school_year_id: this.activeSchoolYear.id
      }
      deletedSubject['schoolYearId'] = this.activeSchoolYear.id
      this.$store.dispatch('deleteSubject', deletedSubject)
      this.closeEditSubjectModal()
    },
    refreshReductions () {
      this.isRefreshing = true
      docendo.refreshSubjectReductions(this.schoolId, this.schoolYearId, success => {
        this.isRefreshing = false
        this.$store.dispatch('readSubjects', this.schoolYearId)
      }, failure => {
        console.log({failure})
      })
    },
    setIsCreateActivityModal (bool) {
      this.isCreateActivityModal = bool
    },
    onSelectTab (tab) {
      this.selectedTab = tab
      this.subjectSearchQuery = ''
    },
    debounceSearch (event) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.subjectSearchQuery = event.target.value
      }, 400)
    },
    toggleSelectedStatusFilters (filter) {
      const idx = this.selectedStatusFilters.indexOf(filter)
      if (idx < 0) {
        this.selectedStatusFilters.push(filter)
      } else {
        this.selectedStatusFilters.splice(idx, 1)
      }
    },
    toggleKlassTag (filter) {
      const idx = this.selectedKlassFilters.indexOf(filter)
      if (idx < 0) {
        this.selectedKlassFilters.push(filter)
      } else {
        this.selectedKlassFilters.splice(idx, 1)
      }
    },
    getUserNames (subjectId) {
      let calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : []
      if (!calIds || calIds.length < 1 || !calIds[0]) {
        return ''
      }
      return calIds.filter(calId => this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'user').map(userCalId => this.allCalendarsInHash[userCalId].name ? this.allCalendarsInHash[userCalId].name : '')
    },
    subjectHasTeachers (subjectId) {
      let calIds = this.subjectsInHash[subjectId] ? this.subjectsInHash[subjectId].calendar_ids : []
      let hasTeachers = false
      calIds.forEach(calId => {
        if (this.allCalendarsInHash[calId] && this.allCalendarsInHash[calId].type === 'user') {
          hasTeachers = true
        }
      })
      return hasTeachers
    },
    readSubjects () {
      if (this.schoolYearId) {
        this.$store.dispatch('readSubjects', this.schoolYearId)
        this.$store.dispatch('readReductions')
      }
    }
  },
  watch: {
    schoolYearId (val) {
      this.readSubjects()
    }
  },
  mounted () {
    this.readSubjects()
    const filters = ['Aktiviteter']
    this.$store.commit('SET_SUBJECT_TYPE_FILTER', filters)
  },
  beforeDestroy () {
    // Clean up any active timeouts
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.request-subjects {
  padding: 1rem;
}

.request-subjects__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.doTable {
  flex: 1;
  border-radius: 4px;
  width: 100%;
}

ul.doTable__items {
  margin: 0;
}

.doTable__klass {
  margin: 0;
}

.doTable__klass__header {
  display: flex;
  justify-content: space-between;
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  padding: 8px;
  font-weight: bold;
}

.doTable__klass__header label {
  color: #c0c0c0;
}

.grade-subjects {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 10px;
  margin: 0;
  border: 1px solid #e2e8f0;
  border-width: 0 1px 0 1px;
  background-color: #ffffff;
}

.grade-subjects_subject {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 4px 6px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
}

.grade-subjects_subject.subject--has-room, .grade-subjects_subject.subject--has-user {
  padding-right: 20px;
}

.grade-subjects_subject.subject--has-room.subject--has-user {
  padding-right: 26px;
}

.grade-subjects_subject.subject--has-room:after {
  content: "\ea38";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.grade-subjects_subject.subject--has-user:after {
  content: "\eaf7";
  position: absolute;
  top: 9px;
  right: 3px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #ffffff;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.grade-subjects_subject.subject--has-room.subject--has-user:after {
  content: '';
  width: 18px;
  top: 10px;
  height: 18px;
  background-image: url('https://app.docendo.dk/static/img/app/bulk_create_subjects_userlocation.png');
  background-size: 100%;
  background-repeat: no-repeat;
}

.subject-dist__header {
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subject-dist__header__left,
.subject-dist__header__right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.request-subjects-grid {
  display: flex;
  gap: 1rem;
}

.do-bttn.do-bttn--request-subject {
  padding: 0 6px;
  height: 24px;
}

.do-input {
  background: #fff;
  height: 26px;
  width: 180px;
  border: 1px solid #e4e4e7;
  box-shadow: 0 0 transparent, 0 0 transparent, 0 1px 2px 0 rgba(0, 0, 0, .05);
  transition: width 0.25s, border 0.25s;
}

.do-input:focus {
  border-color: var(--primary);
}

.do-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.do-table__tasks tbody tr td:first-child {
  font-weight: bold;
}

.td-number {
  text-align: right;
}

.request-subjects__header__left {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>



// WEBPACK FOOTER //
// Reductions.vue?f437c2d0